<app-simple-block-result
  [question]="question"
  [options]="question.block.options"
>
</app-simple-block-result>
